import { render } from "./ElementShadow.vue?vue&type=template&id=5cca6474&scoped=true&ts=true"
import script from "./ElementShadow.vue?vue&type=script&lang=ts"
export * from "./ElementShadow.vue?vue&type=script&lang=ts"

import "./ElementShadow.vue?vue&type=style&index=0&id=5cca6474&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cca6474"]])

export default __exports__